// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ph-0";